import { render, staticRenderFns } from "./ProdEpiMake.vue?vue&type=template&id=45845a14&scoped=true&"
import script from "./ProdEpiMake.vue?vue&type=script&lang=js&"
export * from "./ProdEpiMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45845a14",
  null
  
)

export default component.exports